import type { QuotationFormSampleRow } from './quotationFormTypes';

/** Subtotal baris sampel = jumlah titik × harga × multiplier jadwal berulang (kontrak). */
export function quotationFormSampleLineSubtotal(
  row: QuotationFormSampleRow,
  recurringCount = 1,
): number {
  const jt = Number.parseInt(row.jumlahTitik.trim(), 10);
  const qty = Number.isFinite(jt) && jt >= 1 ? jt : 0;
  const hTrim = row.harga.trim();
  const h = Number.parseFloat(hTrim.replace(',', '.'));
  const price = hTrim !== '' && Number.isFinite(h) && h >= 0 ? h : 0;
  const mult = recurringCount >= 1 ? recurringCount : 1;
  return qty * price * mult;
}
